import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import { followPerson, type SocialStatus } from "../services/social";
export function FollowButton({
  username,
  status,
  onChange,
}: {
  username: string;
  status: SocialStatus;
  onChange: (value: SocialStatus) => void;
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (user?.username === username) return null;
  return (
    <div className="follow-control">
      <button
        className={`btn ${status.followedByViewer ? "" : "follow-button"}`}
        disabled={busy}
        aria-pressed={status.followedByViewer}
        onClick={async () => {
          if (!user) {
            navigate(`/login?next=${encodeURIComponent(`/user/${username}`)}`);
            return;
          }
          setBusy(true);
          setError("");
          try {
            onChange(await followPerson(username, !status.followedByViewer));
          } catch (cause) {
            setError(
              cause instanceof Error
                ? cause.message
                : "Could not follow this person. Try again.",
            );
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy
          ? "Updating..."
          : status.followedByViewer
            ? "Following"
            : "Follow"}
      </button>
      {error && (
        <p className="hint" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
